export default __webpack_public_path__ + "static/media/naval.b554fc67.svg";